import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Perdés horas del domingo armando planificaciones que podrían estar listas en minutos', 'Buscás actividades en internet y todo está pensado para España o México, no para Argentina', 'Cuando llegás al tema "clima argentino" no tenés ejemplos del Zonda, la Sudestada o el Pampero en material didáctico concreto', 'Tus alumnos se aburren porque no conectan el tema con fenómenos que viven todos los días', 'Para la feria de ciencias improvisás experimentos sin tener una guía paso a paso', 'No tenés fichas imprimibles listas para usar y terminás dibujando cuadros en el pizarrón', 'Cuando llegás al tema cambio climático no tenés datos ni evidencias de Argentina para mostrar', 'Sentís que el material que usás no está a la altura de lo que tus alumnos merecen'];
  return <section className="py-20 bg-[#0a1428]" data-id="element-296">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-297">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-298">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-299">
            ❓ ¿Cuántas horas más vas a perder armando material que podría estar
            listo en 5 minutos?
          </h2>

          <div className="space-y-6 text-lg text-slate-300 text-left md:text-center max-w-3xl mx-auto" data-id="element-300">
            <p className="text-[14px]" data-id="element-301">
              Tal vez ya buscaste recursos en YouTube que no tienen contexto
              argentino. Tal vez armás tus actividades desde cero cada año
              porque no encontrás nada que se adapte al curriculum. Tal vez
              cuando llega el tema de cambio climático o tormentas severas no
              tenés material concreto de lo que pasa en Argentina.
            </p>
            <p data-id="element-302">
              <strong className="text-white text-[16px]" data-id="element-303">
                No es falta de vocación. Es que nadie armó el sistema completo
                para vos.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-blue-950/30 border border-blue-900/50 rounded-2xl p-6 md:p-8" data-id="element-304">
          <h3 className="text-xl font-bold text-slate-200 mb-6 text-center" data-id="element-305">
            😓 Esto te está pasando ahora mismo:
          </h3>
          <ul className="space-y-4" data-id="element-306">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-307">
                <div className="mt-1 bg-blue-500/20 p-1 rounded-full shrink-0" data-id="element-308">
                  <X className="w-4 h-4 text-blue-400" data-id="element-309" />
                </div>
                <span className="text-slate-200 font-medium text-[14px]" data-id="element-310">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-311">
          <p className="font-bold text-slate-300 text-[16px]" data-id="element-312">
            🎯 ¿Y si esta fuera la última semana que planificás sin tener todo
            resuelto?
          </p>
        </div>
      </div>
    </section>;
}